import api from '@/plugins/api'
import alert from '@/plugins/alert'

const factoryStore = entity => {
  return {
    namespaced: true,
    state: {
      themeConfig: {},
      items: [],
      item: {},
      loading: false,
      count: 0,
      itemsPerPage: 10,
      searchQuery: {},
      itemsIndependent: []
    },
    actions: {
      async fetchOne({ commit }, id) {
        try {
          const res = await api[entity].fetchOne(id)
          commit('setItem', res)
          return res
        } catch (error) {
          alert.error(error)
        }
      },
      async fetchItems({ commit }, options) {
        try {
          commit('setLoading', true)
          const res = await api[entity].fetch({ _sort: 'createdAt:DESC', _start: 0, _limit: 10, ...options })
          commit('setItems', res)
          return res
        } catch (error) {
          alert.error(error)
        } finally {
          commit('setLoading', false)
        }
      },
      async countItems({ commit }, options) {
        try {
          const res = await api[entity].count(options)
          commit('setCount', res)
          return res
        } catch (error) {
          alert.error(error)
        }
      },
      async createItems({ dispatch }, options) {
        try {
          const res = await api[entity].create(options)
          dispatch('fetchItems')
          return res
        } catch (error) {
          alert.error(error)
        }
      },
      async updateItem({ commit }, { id, ...payload }) {
        try {
          const res = await api[entity].update(id, payload)
          commit('setItem', res)
          return res
        } catch (error) {
          alert.error(error)
        }
      },
      async updateManyItems({ commit }, params) {
        try {
          await api[entity].updateMany(params)
        } catch (error) {
          alert.error(error)
        }
      },
      async removeItem(_, id) {
        const res = await api[entity].remove(id)
        return res
      },
      async getThemeConfig({ commit }, options) {
        try {
          const res = await api[entity].fetchThemeConfig(options)
          commit('setThemeConfig', res)
          return res
        } catch (error) {
          alert.error(error)
        }
      },
      async setItemsPerPage({ commit }, payload) {
        commit('setItemsPerPage', payload)
      },
      setQuerySearch({ commit }, payload) {
        commit('setQuerySearch', payload)
      },
      async fetchItemsIndependent({ commit }, options) {
        try {
          const res = await api[entity].fetch({ _sort: 'createdAt:DESC', ...options })
          commit('setItemIndepedent', res)
          return res
        } catch (error) {
          alert.error(error)
        }
      },
      async createItemsIndependent({ dispatch }, options) {
        try {
          const res = await api['customCategory'].create(options)
          dispatch('fetchItemsIndependent')
          return res
        } catch (error) {
          alert.error(error)
        }
      }
    },
    mutations: {
      setAttributes(state, { name, value }) {
        state[name] = value
      },
      setLoading(state, payload) {
        state.loading = payload
      },
      setItems(state, payload) {
        state.items = payload
      },
      setItem(state, payload) {
        state.item = payload
      },
      setCount(state, payload) {
        state.count = payload
      },
      setItemsPerPage(state, payload) {
        state.itemsPerPage = payload
      },
      setThemeConfig(state, payload) {
        state.themeConfig = payload
      },
      setQuerySearch(state, payload) {
        state.searchQuery = payload
      },
      setItemIndepedent(state, payload) {
        state.itemsIndependent = payload
      }
    },
    getters: {
      items: state => state.items,
      themeConfig: state => state.themeConfig,
      item: state => state.item,
      count: state => state.count
    }
  }
}
export default factoryStore
